import { render } from "./PainelGrupos.vue?vue&type=template&id=46751eb8&scoped=true"
import script from "./PainelGrupos.vue?vue&type=script&lang=js"
export * from "./PainelGrupos.vue?vue&type=script&lang=js"

import "./PainelGrupos.vue?vue&type=style&index=0&id=46751eb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46751eb8"]])

export default __exports__